import { combineReducers } from 'redux';
import { Map } from 'immutable';
import data from './data/reducer';
import core from './core';

const GITLAB_API_INITIAL_STATE = new Map({
    groupId: null,
    assigneeIds: null
});

function gitlabApi(state = GITLAB_API_INITIAL_STATE, action) {
    switch (action.type) {
        case 'TICKETSGIT__SET_GROUPID':
            return core.setGroupId(state, action.groupId);
        case 'TICKETSGIT__SET_ASSIGNEEIDS':
            return core.setAssigneeIds(state, action.assigneeIds);
    }
    return state;
}

export default combineReducers({
    data,
    gitlabApi
});



// WEBPACK FOOTER //
// ./environments/ticketsgit/reducer.js